import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-font-underline",
  "use": "icon-ib-font-underline-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-font-underline\">\r\n    <path d=\"M256 130.090667a21.333333 21.333333 0 0 0-42.666667 0V469.333333a298.666667 298.666667 0 1 0 597.333334 0V130.005333a21.333333 21.333333 0 0 0-42.666667 0V469.418667a256 256 0 0 1-512 0V130.005333zM170.666667 917.333333a21.333333 21.333333 0 0 0 0 42.666667h682.666666a21.333333 21.333333 0 0 0 0-42.666667H170.666667z\" p-id=\"6882\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol